module.exports = __webpack_public_path__ + "static/media/direction.6cb40d0d.svg";